module.exports = __webpack_public_path__ + "static/media/eyebag.ffc4db95.svg";